import script from "./DocsRequestHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsRequestHeader.vue?vue&type=script&setup=true&lang=js"

import "./DocsRequestHeader.vue?vue&type=style&index=0&id=0d9f2a7c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9f2a7c"]])

export default __exports__